export class VariationIdEnhancer {
    public enhance<T>(trackingData: T): T & { product_VariationId: string | undefined } {
        const variationId = VariationIdEnhancer.extractVariationIdFromHTML();
        return { ...trackingData, product_VariationId: variationId };
    }

    private static extractVariationIdFromHTML(): string | undefined {
        const variationId = document.querySelector('#dcs_tracking-data')?.getAttribute('data-variation-id');
        return variationId ?? undefined;
    }
}
